import { render } from "./systemSettingsView.vue?vue&type=template&id=302cb50c"
import script from "./systemSettingsView.vue?vue&type=script&lang=js"
export * from "./systemSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/settings/systemSettingsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "302cb50c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('302cb50c', __exports__)) {
    api.reload('302cb50c', __exports__)
  }
  
  module.hot.accept("./systemSettingsView.vue?vue&type=template&id=302cb50c", () => {
    api.rerender('302cb50c', render)
  })

}


export default __exports__